import { Injectable, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RequstResponse } from '../models/api-models/requst-response.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // check mobile size
  mobileSize = false;
  // set loadding in interceptor
  globalLodding$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
  ) { }
  /**
   * @description check file type png or jpeg and image size under 512
   * @param event file
   * @returns boolean
   */
  validImage(event: any) {
    if (!event.target.files[0]) {
      return false;
    }
    if (!(event.target.files[0].type === 'image/jpeg' ||
      event.target.files[0].type === 'image/png')) {
      this.showErrorSnackBar('پسوند عکس باید png یا jpeg باشد!!');
      return false;
    } else if (Math.round(event.target.files[0].size / 1024) > 3000) {
      this.showErrorSnackBar('حجم عکس باید کمتر از 3 مگابایت باشد!!');
      return false;
    } else {
      return true;
    }
  }

  convertNumberToNumberPrice(credit) {
    return credit ? parseInt(
      credit.toString().replace(/,/g, ''), 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
  }

  convertNumberPriceToNumber(credit) {
    return credit.toString().replace(/,/g, '');
  }

  /**
   * @description check ingore url for loading in interceptor
   * @param req requst
   */
  isIgnoreUrlForLoading(req) {

    if (!(req.url.includes('notification/seen') || (req.url.includes('user/search') && req.body.searchData !== '-1'))) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description set value loadingSrc in app component for show loadding
   */
  changeStateLodding(data: boolean) {
    this.globalLodding$.next(data);
  }
  /**
   * @description check ingore url for Snackbar in interceptor
   * @param req requst
   */
  // ignoreUrlDeleteSnackbar(req) {
  //   if (!(req.url.includes('ticket/details'))) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // ignoreUrlPutSnackbar(req) {
  //   if (
  //     !(req.url.includes('ticket/details'))
  //     && !(req.url.includes('message/all'))
  //     && !(req.url.includes('ticket/all'))

  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // ignoreUrlPostSnackbar(req) {
  //   if (!(req.url.includes('ticket/details'))
  //     && !(req.url.includes('exchange/setType'))
  //     && !(req.url.includes('exchange/requestDetails'))
  //     && !(req.url.includes('exchange/setFinalized'))
  //     && !(req.url.includes('exchange/setRecommandPackage'))
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  /**
   * @description show snakbar
   * @param message string
   * @param action string optional
   * @param duration number optional
   */
  showSnackBar(message: string, action?: string, duration?: number, positionLeft?) {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: positionLeft ? 'left' : 'center',
      panelClass: 'customSnackBar'
      // panelClass: 'succes-snackbar'
    });
  }
  /**
   * @description show error snakbar
   * @param message string
   * @param action string optional
   * @param duration number optional
   */
  showErrorSnackBar(message: string, action?: string, duration?: number) {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: 'center',
      panelClass: 'customErrorSnackBar'
      // panelClass: 'error-snackbar'customErrorSnackBar
    });
  }
  /**
   * @description check width on init
   */
  getWidth() {
    if (window.innerWidth < 600) {
      this.mobileSize = true;
    } else {
      this.mobileSize = false;
    }
  }
  attachImageUrl(response, fieldList: string[]) {
    const temp: RequstResponse = {
      message: response.message,
      data: [],
    };
    if (!response.data[0]) {
      temp.data = response.data;
      fieldList.forEach(field => {
        temp.data[field] = environment.imageUrl + (temp.data[field]);
        const lastIndex = String(temp.data[field]).lastIndexOf('/');
        temp.data[field + 'Name'] = String(temp.data[field]).substring(lastIndex + 1, temp.data[field].length);

      });

    } else {
      response.data.forEach(element => {
        fieldList.forEach(field => {
          if (element[field]) {
            element[field] = environment.imageUrl + (element[field]);
            const lastIndex = String(element[field]).lastIndexOf('/');
            element[field + 'Name'] = String(element[field]).substring(lastIndex + 1, element[field].length);
          }
        });
        temp.data.push(element);
      });

    }

    return temp;
  }
  /**
   * @description clear localStorage data
   */
  clearLocalStorage(): void {
    localStorage.clear();
  }
  /**
   * @description log Out user(clear localStorage data + change rout to /auth)
   */
  logOut() {
    this.clearLocalStorage();
    this.router.navigate(['/login']);
  }

}
